import { trpc } from '@web/lib/trpc';

import { ContactDetailsCard } from './contact-details-card';
import { toast } from 'sonner';
import { useContacts } from '@web/hooks';

type EditContactDialogProps = {
  onClose?: () => void;
};

export function CreateContactDialog({ onClose }: EditContactDialogProps) {
  const { mutateAsync: createContactMutation } =
    trpc.contact.create.useMutation();

  const { fetchRecentContacts } = useContacts();

  return (
    <ContactDetailsCard
      onSubmit={async ({ email, ...data }) => {
        const result = await createContactMutation({
          ...data,
          email: email.length ? email : undefined,
        })
          .then(({ error }) => {
            if (error === 'DUPLICATE') {
              return 'DUPLICATE';
            } else {
              return 'SUCCESS';
            }
          })
          .catch(() => {
            return 'FAILED';
          });

        if (result === 'SUCCESS') {
          toast('Contact successfully created', {
            description: `you can now get in touch with ${data.firstName} !`,
          });

          await fetchRecentContacts();

          onClose?.();
          return;
        }

        if (result === 'DUPLICATE') {
          toast.error('email and/or phone number already exists', {
            description: 'Please used different contact information',
          });
        }

        if (result === 'FAILED') {
          toast.error('Failed to create contact', {
            description: 'Please try again.',
          });
        }

        throw new Error('Failed to create contact');
      }}
      onClose={() => {
        onClose?.();
      }}
      newEntityCreation={true}
    />
  );
}
